import { H4 } from "../typography/H4";

export const PartnerProductOrderHeader = () => {
  return (
    <H4 className="pt-[46px] pb-[22px] text-semantic-text-heading">
      상품 발주
    </H4>
  );
};
